import React  from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import InputBase from '@material-ui/core/InputBase';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import DirectionsIcon from '@material-ui/icons/Directions';

const useStyles = makeStyles((theme) => ({
  root: {
    margin:'0 auto',
    padding: '2px 4px',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButton: {
    padding: 10,
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));



const ItemBarcode = (props) => {

    const classes = useStyles();
    const {SearchBarcode, setSearchBarcode, HandleSearchItemBarcode} = props

    
 const HandleSearch=(e)=>{
    e.preventDefault()
    if(SearchBarcode.trim() !== ""){
        HandleSearchItemBarcode()
    }
 }

    return (
        <Paper component="form" className={classes.root} elevation={5}>
         <InputBase
             className={classes.input}
             placeholder="Barcode"
             inputProps={{ 'aria-label': 'Barcode' }}
             value={SearchBarcode}
             onChange={(e)=>setSearchBarcode(e.currentTarget.value)}
         />
         <IconButton type="submit" className={classes.iconButton} 
                     onClick={HandleSearch}
                     aria-label="search">
             <SearchIcon />
         </IconButton>
         <Divider className={classes.divider} orientation="vertical" />
         <IconButton color="primary" className={classes.iconButton} 
                   onClick={()=>{
                    setSearchBarcode("")
                   }}
                   aria-label="vider">
             <DirectionsIcon />
         </IconButton>
         </Paper>
    )
}

export default ItemBarcode